import { render, staticRenderFns } from "./CampiMacchine.vue?vue&type=template&id=3dbb1487&scoped=true&"
import script from "./CampiMacchine.vue?vue&type=script&lang=js&"
export * from "./CampiMacchine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbb1487",
  null
  
)

export default component.exports